import React, { useState } from 'react';
import TaskStatusDropdown, { TASK_STATUS_OPTIONS } from 'components/tasks/TasksViewer/TaskStatusDropdown';
import { ARCHIVED_STATUS, visibleStatus } from 'components/tasks/TasksViewer/statusChange';
import { usePatchProjectMutation } from 'services/projects/api';
import { Project } from 'services/projects/types';
import ArchiveProjectModal from './ArchiveProjectModal';

type ProjectStatus = NonNullable<Project['status']>;
type ProjectDropdownStatus = ProjectStatus | typeof ARCHIVED_STATUS;

const PROJECT_STATUS_OPTIONS = TASK_STATUS_OPTIONS.filter(
  (option): option is typeof TASK_STATUS_OPTIONS[number] & { value: ProjectDropdownStatus } => (
    option.value !== 'NotDone'
  ),
);

interface ProjectStatusDropdownProps {
  alignToggle?: 'center' | 'start';
  onArchived?: () => void;
  onChange: (status: ProjectStatus, extras?: { cancelReason?: string | null }) => void;
  project: { id?: string; isArchived?: boolean };
  status?: string;
}

const ProjectStatusDropdown = ({
  alignToggle,
  onArchived,
  onChange,
  project,
  status,
}: ProjectStatusDropdownProps) => {
  const [patchProject] = usePatchProjectMutation();
  const [showArchiveModal, setShowArchiveModal] = useState(false);

  return (
    <>
      <TaskStatusDropdown
        alignToggle={alignToggle}
        statusOptions={PROJECT_STATUS_OPTIONS}
        onChange={(nextStatus, extras) => {
          if (nextStatus === ARCHIVED_STATUS) {
            if (project.id && !project.isArchived) {
              setShowArchiveModal(true);
            }
            return;
          }
          onChange(nextStatus, extras);
        }}
        status={visibleStatus(status, project.isArchived)}
      />
      <ArchiveProjectModal
        onConfirm={archiveExclusiveRelated => {
          setShowArchiveModal(false);
          if (!project.id) {
            return;
          }
          onArchived?.();
          patchProject({
            id: project.id,
            isArchived: true,
            ...(archiveExclusiveRelated ? { archiveExclusiveRelated: true } : {}),
          });
        }}
        onHide={() => setShowArchiveModal(false)}
        show={showArchiveModal}
      />
    </>
  );
};

export default ProjectStatusDropdown;
